import { useEffect } from 'react';
import { useToast, TradingToast } from '@trading-ui/core';
import { useQuery } from '@tanstack/react-query';

import { getMasters } from '@/api/services/masters/masters.service';

import useAppStore from '@/store/app.store';

import { parseBackendReason } from '@/utils/error.utils';

import { QUERY_KEYS } from '@/api/config/query-keys';

import type { ProcessedBackendError } from '@/interfaces';

export const useBiofluxMasters = () => {
  const { addToast } = useToast();

  const setMasters = useAppStore((state) => state.setMasters);
  const isLoadingMasters = useAppStore((state) => state.isLoadingMasters);
  const setIsLoadingMasters = useAppStore((state) => state.setIsLoadingMasters);

  const { data, isLoading, error } = useQuery({
    queryKey: [QUERY_KEYS.BIOFLUX_MASTERS],
    queryFn: getMasters,
  });

  useEffect(() => {
    if (data && !isLoading) {
      setMasters(data);
      setIsLoadingMasters(false);
    }
  }, [data, isLoading, setMasters, setIsLoadingMasters]);

  useEffect(() => {
    if (error) {
      const errorMessage = parseBackendReason(error as Error | ProcessedBackendError);
      addToast(<TradingToast type="error" title="Error" message={errorMessage} />);
    }
  }, [error, addToast]);

  return { isLoading: isLoadingMasters };
};

export default useBiofluxMasters;
